<div class="screen-container">
  <div *ngIf="!isSummary; else summaryBlock">
    <app-card [title]="'monthlySales.title' | translate">
      <div left-content>
        <ng-template [ngTemplateOutlet]="monthlySalesBlock"></ng-template>
      </div>
      <div right-content>
        <app-contact></app-contact>
      </div>
    </app-card>
  </div>

  <ng-template #summaryBlock>
    <div class="summary">
      <ng-template [ngTemplateOutlet]="monthlySalesBlock"></ng-template>
    </div>
  </ng-template>
</div>

<ng-template #monthlySalesBlock>
  <form [formGroup]="monthlySalesForm">
    <div content class="content-container">
      <div class="input-container">
        <app-currency-input
          [label]="'monthlySales.estimatedMonthlySales'"
          [control]="monthlySales"
          [error]="getErrors('monthlySales')"
        ></app-currency-input>
      </div>
      <app-infobox
        [title]="'monthlySales.infobox.title' | translate"
        [content]="'monthlySales.infobox.content' | translate"
      >
      </app-infobox>
    </div>
    <ng-template *ngIf="!isSummary" [ngTemplateOutlet]="monthlySalesButton"></ng-template>
  </form>
</ng-template>

<ng-template #monthlySalesButton>
  <div actions class="navigationButtons">
    <button
      (click)="handleNextButtonClick()"
      mat-flat-button
      color="primary"
    >
      {{ "monthlySales.nextButtonText" | translate }}
    </button>
  </div>
</ng-template>